import { useTranslation } from '@mc/i18n'
import { Separator } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'

import TableOfContents from 'components/TableOfContents'

import AboutInstructor from '../AboutInstructor'
import ChaptersList from '../ChaptersList'
import InstructorBio from '../InstructorBio'
import InstructorInfo from '../InstructorInfo'
import Preview from '../Preview'
import { getNavItems } from './utils'

const Details = () => {
  const { chapter } = useStaticData()
  const { t } = useTranslation('@mc/next')

  return (
    <div className='container mc-pb-9'>
      <div className='row'>
        <div className='col-12 col-lg-4 order-md-2'>
          <InstructorBio />
          <ChaptersList />
        </div>
        <div className='col-12 col-lg-8'>
          <TableOfContents
            title={t('lesson.details.nav.title')}
            navItems={getNavItems(chapter)}
          />
          <Preview />
          <Separator className='mc-my-0' />
          <AboutInstructor />
          <Separator className='mc-my-0' />
          <InstructorInfo />
        </div>
      </div>
    </div>
  )
}

export default Details
